import {
  extendTheme,
  type StyleFunctionProps,
  withDefaultColorScheme,
} from "@chakra-ui/react";
import {
  colors,
  fonts,
  fontSizes,
  fontWeights,
  lineHeights,
  letterSpacings,
  textStyles,
} from "./tokens";

const styles = {
  global: {
    "html, body": {
      fontFamily: fonts.body,
      bg: colors.gray[50],
      color: colors.gray[600],
    },
    p: { fontFamily: fonts.body },
    ul: { fontFamily: fonts.body },
    ol: { fontFamily: fonts.body },
    li: { fontFamily: fonts.body },
    code: { fontFamily: fonts.mono },
    pre: { fontFamily: fonts.mono },
  },
};

const components = {
  Button: {
    baseStyle: {
      transition: "all 0.25s ease-in-out",
      _hover: {
        transform: "translateY(-2px)",
        filter: "brightness(1.15)",
        boxShadow: "md",
      },
      _active: {
        transform: "translateY(0px)",
        filter: "brightness(0.95)",
        boxShadow: "sm",
      },
    },
  },
  Radio: {
    baseStyle: (props: StyleFunctionProps) => ({
      control: {
        bg: "transparent",
        borderWidth: "1px",
        borderColor: colors.gray[300],
        _hover: { borderColor: colors.brand[600] },
        _checked: {
          bg: "transparent",
          borderColor: `${props.colorScheme}.500`,
          _before: {
            content: `""`,
            display: "block",
            w: "8px",
            h: "8px",
            bg: `${props.colorScheme}.500`,
            borderRadius: "full",
          },
        },
        _icon: { display: "none" },
      },
      label: { textStyle: "body-md" },
    }),
    sizes: {
      md: { label: { ...textStyles["body-md"] } },
      lg: { label: { ...textStyles["body-lg"] } },
    },
    defaultProps: { colorScheme: "brand" },
  },
};

const chakraTheme = extendTheme(
  withDefaultColorScheme({
    colorScheme: "brand",
    components: ["Button", "Checkbox", "Radio", "Input"],
  }),
  {
    breakpoints: {
      base: "0px",
      sm: "480px",
      md: "768px",
      lg: "992px",
      xl: "1280px",
      "2xl": "1536px",
      "3xl": "1920px",
    },
    colors,
    fonts,
    fontSizes,
    fontWeights,
    lineHeights,
    letterSpacings,
    textStyles,
    styles,
    components,
  }
);

export default chakraTheme;
